export function toMetadataFileName(artist: string, title: string): string {
  const raw = `${artist} - ${title}.jpg`;
  return encodeURIComponent(raw);
}
